<template>
  <div class="view-products" data-cy="view-products">
    <router-link class="launch-calendar-btn" to="/launch-calendar" data-cy="launch-calendar-button">
      <BackstageButton icon-right="calendar">
        {{ $t('viewLaunchCalendar.launch_calendar_button') }}
      </BackstageButton>
    </router-link>
    <onp-products-list></onp-products-list>
  </div>
</template>

<script lang="ts">
import BackstageButton from '@/components/common/BackstageButton.vue';
import { useBPLogger } from '@/composables/business-process-logger';
import '@onrunning/on-products-ui/dist-vue/on-products-ui.css';
import '@onrunning/on-products-ui/dist-vue/on-products-ui.umd.js';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'view-products',
  components: {
    BackstageButton,
  },
  setup() {
    const { pageViewBPLog } = useBPLogger();

    return {
      pageViewBPLog,
    };
  },
  mounted() {
    console.log(this.pageViewBPLog(true, { page_name: 'view-products' }));
  },
});
</script>
]
<style lang="scss">
@mixin nav-container {
  width: fit-content;
  border-radius: 10rem;
  background-color: var(--primary-bg-color);
  font-family: inherit;
  text-transform: none;
  font-size: 0.875rem;
  gap: 0.75rem;
  padding: 0;
}

@mixin nav-option {
  @include flex-align-center;
  height: 2.8125rem;
  width: 9.625rem;
  border: none;
  padding: 0;
  justify-content: center;
  border-radius: 10rem;
}

@mixin flex-align-center {
  display: flex;
  align-items: center;
}

.view-products {
  @include common-container;

  .launch-calendar-btn {
    float: right;
    padding-right: 22px;
  }

  onp-products-list {
    * {
      font-family: 'On' !important;
    }

    .search {
      padding: 1.0938rem 1.875rem;
      height: 1.25rem;
    }

    .close-search {
      padding: 1.0938rem 0.625rem;
    }

    .products-list-cnt {
      header .logo {
        display: none;
      }

      .user-menu .home-icon {
        background-image: none !important;
        @include icon-image('@/assets/img/icons/black_chevron_left.svg', var(--primary-text-color));
        height: 24px;
        width: 24px;
      }

      .main-groups {
        position: relative;
        background-color: transparent;
        padding: 1rem 0;
        nav {
          @include nav-container;

          a {
            @include nav-option;

            &.selected {
              border: 0.0625rem solid var(--primary-button-bg-color);
              box-shadow:
                0rem 0rem 0.0625rem var(--bg-remark-selected-color),
                0rem 0.25rem 0.5rem var(--bg-remark-selected-color);
            }
          }
        }
      }

      header {
        z-index: 1;
        background: var(--bg-page-color);
        padding: 0 1.25rem;
        display: flex;
        flex-direction: row-reverse;
        margin-top: 1.5rem;

        .user-menu {
          display: block;
          cursor: pointer;
        }

        &.hidable .user-menu {
          display: none;
        }
        .menu {
          @include flex-align-center;
          justify-content: flex-end;
          width: 100%;
          height: 4.8125rem;
          box-shadow: unset;

          .search {
            top: 0;
            bottom: 0;
            margin: auto;
            padding: 0;
            height: fit-content;
            transition: position 1ms;
          }

          .search-icon {
            @include flex-align-center;
            background: url('@/assets/img/ico-search.svg') no-repeat;
            background-position: left 1.0313rem center;
            height: 2.625rem;
            width: 12.5rem;
            border: 0.0625rem solid var(--primary-button-bg-color);
            border-radius: 10rem;
            padding: 0 1.0313rem;

            &::after {
              content: 'Search';
              margin-left: 1.875rem;
              font-style: normal;
              font-weight: 400;
              font-size: 0.875rem;
            }
          }

          &.searching {
            & + div.main-groups {
              display: none;
            }

            .search {
              right: 15.625rem !important;
              .search-icon {
                background: url('@/assets/img/ico-search.svg') no-repeat;
                border: none;
                background-position: left center;
                width: 2.5rem;

                &::after {
                  display: none;
                }
              }
            }

            .close-search {
              top: 0;
              bottom: 0;
              margin: auto;
              padding-top: 0;
              padding-bottom: 0;
              &::after,
              &::before {
                background-color: var(--primary-text-color);
              }
            }
          }

          .search-input {
            margin: 0;
            padding: 0 2.8125rem;
            width: 18.75rem;
            height: 2.625rem;
            border: 0.0625rem solid var(--primary-button-bg-color);
            border-radius: 10rem;
            overflow: hidden;

            input {
              margin: 0;
              padding: 0;
              width: 100%;
              height: 2.625rem;
              background-color: transparent;
              font-family: inherit;
              font-weight: 400;
              font-size: 0.875rem;
              line-height: 150%;
            }
          }
        }

        .search,
        .close-search {
          cursor: pointer;
        }
        .search-input input {
          color: var(--primary-text-input-color);
        }
      }

      .product-groups-list {
        padding: 0;
        margin: auto;
        background: var(--bg-page-color);
        margin-bottom: 2.5rem;

        &.fixed {
          display: none;
        }

        li {
          margin: 0;
          padding: 0 1.25rem;
          margin-bottom: 2.5rem;
          cursor: pointer;
          border: none;

          &.collapsed {
            margin-bottom: 0;
          }

          h4 {
            color: var(--primary-text-title-color);
            text-align: left;
            font-weight: 400;
            font-size: 1.25rem;
            line-height: 150%;
            text-transform: none;
            padding: 1.375rem 0;

            &::after {
              background: url('@/assets/img/ico-chevron-down.svg') no-repeat center;
              cursor: pointer;
              height: 1.875rem;
              width: 1.0625rem;
              right: 2.0313rem;
              top: 1.375rem;
            }
          }
        }
      }
    }

    .products-search-list-cnt .search-results .results ul.products-list,
    .products-list-cnt .product-groups-list li ul.products-list {
      border-radius: 0.25rem;
      overflow: hidden;

      li {
        cursor: pointer;
        background-color: var(--primary-bg-color);
        height: 4.125rem;
        padding: 0 1.25rem;
        align-items: center;
        border: none;
        margin-bottom: 0.0625rem;

        .text {
          padding: 0;
          h2 {
            color: var(--primary-text-focus-color);
            font-size: 0.875rem;
            font-weight: 700;
            line-height: 150%;
            padding: 0;
          }

          h3 {
            color: var(--primary-text-remark-color);
            margin: 0;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 150%;
          }
        }

        .new {
          @include flex-align-center;
          margin: 0 0.9375rem;

          .circle {
            margin: 0;
          }
        }

        img {
          height: 3.125rem;
          width: 3.125rem;
          margin: 0;
          background: url('@/assets/img/logo-footer.svg') no-repeat center center;
        }
      }
    }
  }

  onp-products-search-list {
    .products-search-list-cnt {
      top: 0;
      position: relative;
      margin-bottom: 2.5rem;
      .search-results {
        background-color: var(--bg-page-color);

        .results {
          @include main-max-with;

          margin: auto;

          .products-list {
            background-color: var(--bg-page-color);
            padding: 0 1.25rem;
          }
          .main-groups {
            background-color: var(--bg-page-color);
            padding: 1rem 1.25rem;
            ul {
              @include nav-container;

              li {
                @include nav-option;
                color: var(--primary-text-color);
                cursor: pointer;

                &::before {
                  display: none;
                  width: 0;
                }

                &.selected {
                  border: 0.0625rem solid var(--primary-button-bg-color);
                  box-shadow:
                    0rem 0rem 0.0625rem var(--bg-remark-selected-color),
                    0rem 0.25rem 0.5rem var(--bg-remark-selected-color);
                }
              }
            }
          }
        }
      }
    }
  }

  onp-product-view {
    .product-view {
      .product-view-cnt {
        .main-info {
          background: var(--bg-page-color);
          color: var(--primary-text-color);

          .title h2 {
            color: var(--primary-text-focus-color);
          }
          .variant-colors span {
            color: var(--primary-text-color);
          }
          .variant-colors span.selected {
            color: var(--subtle-color);
          }
        }

        h3 {
          color: var(--primary-text-remark-color);
        }

        p {
          color: var(--primary-text-color);
        }

        .spec p.gray {
          color: var(--subtle-color);
        }

        .accordion-item:not(.selected),
        .color:not(.selected),
        .image-thumbs img:not(.selected),
        .arrow-cnt {
          cursor: pointer;
        }

        .spider .row .columns .column.selected p {
          color: var(--primary-text-focus-color);
        }

        .key-selling-points,
        .key-points {
          background: var(--bg-page-color);

          .external-video iframe {
            height: 460px;
          }

          .ask .buttons .border-btn {
            background-color: var(--primary-button-bg-color);
            color: var(--secondary-text-color);
            border-radius: 100px;
          }
        }
      }
    }
  }
}

@include breakpoint(small) {
  .view-products onp-products-list .products-list-cnt {
    header {
      padding: 0 0.625rem;
      margin-top: 0.625rem;

      .menu .search-icon {
        border: none;
        width: 2.5rem;
        &::after {
          display: none;
        }
      }
    }

    .main-groups nav {
      gap: 0.3125rem;
      a {
        width: 5.9375rem;
      }
    }

    .product-groups-list li {
      padding: 0 0.625rem;
    }
  }

  .view-products onp-products-search-list .products-search-list-cnt .search-results .results {
    .main-groups {
      padding: 1rem 0.625rem;

      ul {
        gap: 0.3125rem;

        li {
          width: 5.9375rem;
        }
      }
    }

    .products-list {
      padding: 0 0.625rem;
    }
  }
}
</style>
